<template>
  <div class="send-to-phone">
    <h2 class="section-header">
      <contentful-text :item="contentfulText('checkout-download-send-to-phone-head')" />
    </h2>
    <div class="row row--mb-20">
      <div class="col-sm-9">
        <div class="send-to-phone__lede">
          <contentful-text :item="contentfulText('checkout-download-send-to-phone-lede')" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <label class="send-to-phone__input-label">
          <contentful-text :item="contentfulText('checkout-download-send-to-phone-phonenumber-input-label')" />
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <input
          v-mask="'000-000-0000'"
          v-model="phoneNumber"
          type="text"
          placeholder="ex: 555-123-4567"
          class="send-to-phone__phone-number-input"
        >
      </div>
      <div class="col-xs-12 col-sm-4 col-md-2">
        <button
          :disabled="!phoneNumberValid"
          :class="submitBtnClasses"
          type="button"
          @click="handleSendToPhoneClick"
        >
          <contentful-text :item="contentfulText('checkout-download-send-to-phone-submit-button-label')" />
          <i
            v-if="sendToPhoneSubmitting"
            class="fa fa-spinner fa-spin"
          />
        </button>

        <div
          v-if="sendToPhoneResponse"
          :class="responseClasses"
        >
          {{ sendToPhoneResponse.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstagramDownload',
  data () {
    return {
      phoneNumber: null,
      sendToPhoneResponse: null,
      sendToPhoneSubmitting: false
    }
  },
  computed: {
    siteRoot () {
      return this.$store.state.siteRoot
    },
    viewModel () {
      return this.$store.state.viewModel
    },
    content () {
      return this.viewModel.PageContent
    },
    phoneNumberValid () {
      if (!this.phoneNumber) {
        return false
      }

      return this.phoneNumber.match(/^\d{3}-\d{3}-\d{4}$/)
    },
    submitBtnClasses () {
      return {
        button: true,
        'send-to-phone__submit': true,
        'send-to-phone__submit--disabled': !this.phoneNumberValid
      }
    },
    responseClasses () {
      return {
        'send-to-phone__response-msg': true,
        'alert': true,
        'alert-success': this.sendToPhoneResponse.success === true,
        'alert-danger': this.sendToPhoneResponse.success === false
      }
    }
  },
  watch: {
    sendToPhoneResponse (v, ov) {
      if (v !== null) {
        setTimeout(() => { this.sendToPhoneResponse = null }, 3000)
      }
    }
  },
  methods: {
    handleSendToPhoneClick () {
      const postData = {
        phoneNumber: this.phoneNumber,
        url: window.location.href,
        digitalPackageId: this.viewModel.Product.DigitalPackageId,
        orderProductId: this.viewModel.OrderProductId,
        hash: this.viewModel.Hash,
        viaAjax: true
      }

      this.sendToPhoneSubmitting = true

      this.$http.post(`${this.siteRoot}Checkout/SendToPhone`, postData)
        .then(response => {
          if (response.status === 200) {
            if (response.data.success === true) {
              this.sendToPhoneResponse = response.data
            } else {
              this.handleSendToPhoneFail()
            }
          } else {
            this.handleSendToPhoneFail()
          }
        })
        .catch(e => {
          this.handleSendToPhoneFail()
        }).finally(() => {
          this.sendToPhoneSubmitting = false
        })
    },
    handleSendToPhoneFail () {
      this.sendToPhoneResponse = {
        success: false,
        message: this.contentfulText('checkout-download-send-to-phone-fail-message').Content
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.send-to-phone {
  &__lede {
    text-align: center;
  }

  &__input-label {
    font-family: $font-open-sans;
    font-size: 14px;
    font-weight: bold;
  }

  &__phone-number-input {
    height: 48px;
    padding: 0.25em;
    text-align: center;
    width: 100%;
    margin: 0 0 20px 0;
  }

  &__submit {
    border: none;
    font-size: 18px;
    font-weight: bold;
    height: 48px;
    padding: 0 40px;
    text-align: center;
    width: 100%;

    &--disabled {
      background-color: #999;
      cursor: not-allowed;
    }
  }

  &__response-msg {
    margin: 10px 0;
  }

  @media screen and (min-width: $screen-sm-min) {
    &__lede {
      text-align: left;
    }
  }
}

.row--mb-20 {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/checkout-download/components/SendToPhone.vue